import { Button, Grid, Paper } from "@mui/material";
import React, { useState } from "react";
import AnalyticsCard from "../components/ui/AnalyticsCard";
import {
  BlockOutlined,
  CalendarMonth,
  Delete,
  InfoOutlined,
  Mail,
  Message,
  Person,
  Phone,
} from "@mui/icons-material";
import TableDataLoader from "../components/dataGrid/TableDataLoader";
import { toApiUrl } from "../utils/generic";
import SimpleDialog from "../components/dialogs/SimpleDialog";
import useTheme from "../store/hooks/useTheme";
import Title from "../components/ui/Title";
import withAuth from "../hoc/withAuth";
import ActionsMenu from "../components/dataGrid/ActionsMenu";
import useDataSlice from "../components/dataGrid/useDataSlice";
import axios from "../apiClient";
import { addNotification } from "../store/actions/notifications";
import { Link } from "react-router-dom";
const MessageColumns = [
  {
    name: "id",
    label: "Message ID",
  },
  {
    name: "name",
    label: "User",
    renderComponent: ({ row }) => `${row.name} ${row.last_name}`,
  },
  { name: "email", label: "Email" },
  { name: "phone", label: "Phone" },
  {
    name: "created_at",
    label: "Created",
    renderComponent: ({ value }) => new Date(value).toLocaleString("el-GR"),
  },
  {
    name: "actions",
    label: "Actions",
    renderComponent: ActionsMenu,
  },
];

function MessagesPage() {
  const theme = useTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const [dataSlice, getData, setLoading] = useDataSlice("messages");
  return (
    <Grid container spacing={2}>
      <Grid item md={12} xs={12}>
        <AnalyticsCard title="Messages" icon={<Message />}></AnalyticsCard>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        style={{ maxWidth: "100%", overflowX: "auto" }}
      >
        <Paper sx={{ p: 1 }} elevation={0}>
          <TableDataLoader
            identifier="messages"
            entityName="results"
            endpoint={toApiUrl("/messages")}
            columns={MessageColumns}
            renderToolbarChildren={() => (
              <Button
                startIcon={<BlockOutlined color="error" />}
                variant="contained"
                color="primary"
                LinkComponent={Link}
                to="/messages/blacklist"
              >
                Block Users
              </Button>
            )}
            actions={[
              {
                type: "Info",
                title: "Info",
                action: (row) => setSelectedRow(row),
                icon: <InfoOutlined />,
              },
              {
                type: "Delete",
                title: "Delete",
                action: async (row) => {
                  try {
                    setLoading(true);
                    await axios.delete(toApiUrl(`/messages/${row.id}`));
                    await getData(
                      dataSlice?.page,
                      dataSlice?.view,
                      dataSlice?.filters
                    );
                    addNotification("Message deleted", "success");
                    return true;
                  } catch (error) {
                    addNotification("Message was not deleted", "error");
                  } finally {
                    setLoading(false);
                  }
                },
                icon: <Delete />,
              },
            ]}
          />
        </Paper>
      </Grid>
      <SimpleDialog open={!!selectedRow} onCancel={() => setSelectedRow(null)}>
        <Grid container spacing={2}>
          <Grid item>
            <Title>
              <Person sx={{ mr: 2 }} /> {selectedRow?.name}{" "}
              {selectedRow?.last_name}
            </Title>
          </Grid>
          <Grid item>
            <Title>
              <Mail sx={{ mr: 2 }} /> {selectedRow?.email}
            </Title>
          </Grid>
          {selectedRow?.phone ? (
            <Grid item>
              <Title>
                <Phone sx={{ mr: 2 }} /> {selectedRow?.phone}
              </Title>
            </Grid>
          ) : null}
          <Grid item>
            <Title>
              <CalendarMonth />
              {new Date(selectedRow?.created_at)?.toLocaleString("el-GR")}
            </Title>
          </Grid>
          <Grid item md={12} xs={12}>
            <p
              style={{
                padding: "40px",
                background: theme?.themeMode === "dark" ? "#444" : "#eee",
              }}
            >
              {selectedRow?.message}
            </p>
          </Grid>
        </Grid>
      </SimpleDialog>
    </Grid>
  );
}
export default withAuth(MessagesPage);
